// Orchestrates what happens when the editor reports a new event string:
// updates input state, resets downstream chain outputs, and kicks off
// validation. Short-circuits when the string is unchanged — the ace editor's
// blur fires setValue even with no content change, and we don't want to
// re-validate or disable tabs on every interaction.
export default function buildOnInputEventChange({ inputEvent, setInputEvent, chainState, validate }) {
  return eventString => {
    if (eventString === inputEvent) {
      return;
    }

    setInputEvent(eventString);
    chainState.onInputEventChange();
    validate(eventString);
  };
}
